var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHorizontal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 444,
    height: 47,
    viewBox: "0 0 444 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M361.12 45.95H315.17L305.98 36.76V0H315.17V32.86L318.66 36.76H357.56L361.12 32.86V0H370.31V36.76L361.12 45.95Z",
    fill: "#C71D3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.15 9.19H72.8203V0H127.96L137.15 9.19Z",
    fill: "#C71D3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.15 27.57H72.8203V18.38H127.96L137.15 27.57Z",
    fill: "#C71D3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.15 45.96H72.8203V36.76H127.96L137.15 45.96Z",
    fill: "#C71D3B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.89996V0.709961H55.15L64.34 9.89996V19.09L55.29 28.28H45.96L64.34 46.67H52.85L34.47 28.28H9.18999V46.67H0V19.09H50.25L55.15 14.34L50.52 9.89996H0Z",
    fill: "#C71D3B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M232.449 9.28V0.0899963L287.589 0L296.779 9.28V18.46L292.749 23.09L296.779 27.67V36.86L287.589 46.05H232.449V18.48L283.729 18.47L287.589 13.59L283.729 9.28998H232.449V9.28ZM241.649 27.66V36.85H283.739L287.599 32.27L283.739 27.66H241.649Z",
    fill: "#C71D3B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M146.34 9.19V0H201.49L210.68 9.19V36.76L201.49 45.96H146.34V18.38H155.53V36.76H197.09L201.49 32.16V13.23L197.18 9.19H146.34Z",
    fill: "#C71D3B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M379.512 9.19V0H434.652L443.842 9.19V36.76L434.652 45.95H379.512V18.38H388.702V36.76H430.342L434.652 32.16V13.23L430.342 9.19H379.512Z",
    fill: "#C71D3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontal);
export default __webpack_public_path__ + "static/media/Logo_Horizontal.860bbedbb9daff276e0ccba51ff7678d.svg";
export { ForwardRef as ReactComponent };